// extracted by mini-css-extract-plugin
module.exports = {"newarrival":"homepage2_newarrival__2bs7w"};